import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

/**
 * NagusiBackNav
 *
 * Componente unificado para navegación de retorno ('Volver al foro' / 'Volver a Aurrera Jokoak').
 * Atributos aceptados:
 * - parentUrl: string opcional (ej: '/aurrera-jokoak').
 * - parentLabel: string opcional (ej: 'Aurrera Jokoak').
 * - title: string opcional para contexto.
 * - rightContent: vnode opcional para ubicar a la derecha.
 */
export default class NagusiBackNav extends Component {
  view(vnode) {
    const _ref = vnode.attrs || {},
      parentUrl = _ref.parentUrl,
      parentLabel = _ref.parentLabel,
      parentIcon = _ref.parentIcon,
      crumbs = _ref.crumbs,
      title = _ref.title,
      rightContent = _ref.rightContent;
    return m("div", {
      className: "NagusiBackNav"
    }, m("div", {
      className: "NagusiBackNav-left"
    }, m(Link, {
      href: app.route('index'),
      className: "NagusiBackNav-btn NagusiBackNav-btn--home"
    }, m("i", {
      className: "fas fa-home"
    }), m("span", {
      className: "NagusiBackNav-text"
    }, "Foro")), crumbs && crumbs.length > 0 ? crumbs.map((crumb, idx) => [m("span", {
      className: "NagusiBackNav-separator",
      key: "sep-".concat(idx)
    }, m("i", {
      className: "fas fa-chevron-right"
    })), m(Link, {
      href: crumb.url,
      className: "NagusiBackNav-btn NagusiBackNav-btn--parent",
      key: "crumb-".concat(idx)
    }, crumb.icon && m("i", {
      className: crumb.icon
    }), m("span", {
      className: "NagusiBackNav-text"
    }, crumb.label))]) : parentUrl && parentLabel && [m("span", {
      className: "NagusiBackNav-separator",
      key: "sep-parent"
    }, m("i", {
      className: "fas fa-chevron-right"
    })), m(Link, {
      href: parentUrl,
      className: "NagusiBackNav-btn NagusiBackNav-btn--parent",
      key: "btn-parent"
    }, m("i", {
      className: parentIcon || 'fas fa-gamepad'
    }), m("span", {
      className: "NagusiBackNav-text"
    }, parentLabel))], title && m("span", {
      className: "NagusiBackNav-currentTitle"
    }, m("span", {
      className: "NagusiBackNav-separator"
    }, "/"), m("span", {
      className: "NagusiBackNav-titleText"
    }, title))), rightContent && m("div", {
      className: "NagusiBackNav-right"
    }, rightContent));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/common/NagusiBackNav', NagusiBackNav);